import type { ZapiPath } from '@weft/zapi-types';
import { PATH_ACCESS_LEVELS } from '@weft/zapi-types';
import { NEST_API_TAGS } from '../../api-tags';
import { CONTRACT_ID_PATH_PARAM } from '../../contract-paths/contract-id-path';

export const GET_CONTRACT_BILLING_SCHEDULE_REPORT_PATH = {
  accessLevel: PATH_ACCESS_LEVELS.PRIVATE,
  route: '/report/contract-billing-schedule/{contractId}',
  pathParams: {
    [CONTRACT_ID_PATH_PARAM.name]: CONTRACT_ID_PATH_PARAM,
  },
  tags: NEST_API_TAGS.REPORT,
} satisfies ZapiPath;

export type GetContractBillingScheduleReportPath = typeof GET_CONTRACT_BILLING_SCHEDULE_REPORT_PATH;